import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./index.css";
import { on } from '@all-in-one/cross-domain'
import { store } from "../../../store";
import { Card, Divider, Page, Tabs } from "@shopify/polaris";
import PartnersClass from "../Partners/components/PartnersClass";
import SheetContactUs from "../../../components/ContactUsSheetExample/SheetExample";
class Index extends Component {
  
  state = {
    shopify_domain: '',
    app: '518111167166087168', // 中台提供
    loading: true,
    searchPar: '',          // 参数
    dVersion: 'local',
    selected: 0,
}

UNSAFE_componentWillMount() {
  const locals = this.props.location;
  const params = new URLSearchParams(locals.search || "");
  // Keep tab query out of iframe src, otherwise tab switches can change iframe URL
  params.delete("selected_tab");
  const remain = params.toString();
  const searchPar = remain ? `&${remain}` : "";
  this.setState({
      searchPar,
      dVersion: process.env.REACT_APP_ENV
  })
}

  //进入页面调用接口
  componentDidMount() {
    try {
      this.setDomain();
      store.subscribe(() => {
          this.setDomain();
      })
      on("all-in-one", this.openWillDesk);
    const { search } = window.location;
    const urlParams = new URLSearchParams(search);
    const select_tab = urlParams.get('selected_tab');
    this.setState({
        selected: select_tab ? Number(select_tab) : 0,
    })
  } catch (error) {
      
  }
  }
  setDomain = () => {
    let _store = store.getState().languageReducer.subScriptData;
    this.setState({
        shopify_domain: _store.domain,
        email: _store.email,
    })
}
  // 调起客服
  openWillDesk = (msg) => {
    try {
        window.Willdesk.show();
        if (msg) {
            window.Willdesk.chat(msg);
        }
    } catch (e) { }
}

// 监听加载
onloadIframe = () => {
  this.setState({
      loading: false,
  })
}
handleTabChange = (selected) => {
  this.setState({ selected });
  // Avoid history.push/routeJump: query-only URL change remounts this page
  // (Router uses component={() => ...} which remounts when location updates).
  const url = `/admin/recommended-apps?selected_tab=${selected}`;
  window.history.replaceState(window.history.state, "", url);
}
  render() {
    const {
      shopify_domain,
      app,
      email,
      searchPar,
      dVersion,

  } = this.state;
  const tabs = [
    {
      id: 'all-customers-1',
      content: 'By Channelwill',
      accessibilityLabel: 'All customers',
      panelID: 'all-customers-content-1',
    },
    {
      id: 'accepts-marketing-1',
      content: 'By Partners',
      panelID: 'accepts-marketing-content-1',
    },
  ];
   // 设置iframe（域名/邮箱就绪后再渲染，避免 src 变化导致重复加载）
   const edEmail = email
     ? btoa(email).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")
     : "";
   const urlDomain = dVersion === 'pre' ? 'https://aio-apps.channelwill.com' : 'https://aio-apps-test.channelwill.com';
   const src = shopify_domain && edEmail
     ? `${urlDomain}/?shopify_domain=${shopify_domain}&app=${app}&email=${edEmail}&has_combo=true${searchPar}`
     : "";

    const pageContent = src ? (
        <iframe id="all-in-one" className="h-screen w-full border-none" title="recommended-apps" src={src} onLoad={this.onloadIframe}></iframe>
    ) : null;

    return (
      <div style={{ background: 'rgb(241, 241, 241)',paddingBottom:'24px' }}>
        <Page fullWidth={false} title={'Recommendation'}>
        {/* 页面内容 */}
        <Card padding={0}>
        <Tabs tabs={tabs} selected={this.state.selected} onSelect={this.handleTabChange}>
          <Divider />
          {/* Keep both panels mounted to avoid iframe/Partners remount refetch on tab switch */}
          <div style={{ display: Number(this.state.selected) === 0 ? "block" : "none" }}>
            {pageContent}
          </div>
          <div style={{ display: Number(this.state.selected) === 1 ? "block" : "none" }}>
            <PartnersClass />
          </div>
        </Tabs>
        </Card>
         <SheetContactUs
        helpCenterText={'Dropshipman'}
        helpCenterLink={'https://www.dropshipman.com/blog'}
      />
         </Page>
      </div>
    );
  }
}

export default withRouter(Index);
